// 全身のメーカーのスマホだけの右の列（2026-10-23〜。クラシック版の右の列と同じ考え方）。page.php の #sideRail
//   元に戻す・やり直す（左下の元に戻すの代わり）、色・柄（色の列の中の切りかえの代わり）、左右（め など。押すたびに 両方 → 左 → 右）、
//   調整（押すと左の色の列が、反転・移動・大きさなどの道具の列 #tools に入れかわる。もう一度押すか、色・柄を押すと色に戻る）。
//   使えないものは出さない。PC・ほかのメーカーでは CSS で出さない（tallUI のときだけ動かす）
import { S } from './state.js';
import { C } from './core/model.js';
import { txt } from './text.js';
import { catByKey, tallUI } from './store.js';
import { $, keyOf } from './util.js';
import { canPattern } from './core/pattern.js';
import { histStep } from './history.js';
import { lrOn, LR_LABELS, buildColors, colorUsable } from './lr.js';
import { isPair, layerSlot, slotKeys } from './merge.js';
import { setPairSlot } from './categories.js';

let adjusting = false;
// 左の色の列をしまっているか（色のボタンをもう一度押す。クラシック版と同じ。2026-10-28 ユーザー）。カテゴリを替えてもそのまま、色・柄を押すと出す
let colorsOff = false;
function setColorsOff(off: boolean) {
  colorsOff = off;
  $('app').classList.toggle('colors-off', off);
}
// 色のボタンが「押している」ときか（色の列に色を出している）
function colorShown() {
  const cat = catByKey[S.selKey], st = cat ? C.state[keyOf(cat)] : undefined;
  const usable = !!cat && colorUsable(cat);
  const onPattern = !!cat && !!st && canPattern(cat) && S.colorTab === 'pattern';
  return usable && !adjusting && !onPattern && !colorsOff;
}
// 調整の道具の列を出しているか（色の列の代わり）
export function setAdjust(on: boolean) {
  adjusting = on;
  $('app').classList.toggle('adjusting', on);
  updateSide();
}
// 今のカテゴリに合わせて、出すボタン・押している印をそろえる（buildColors・updateTools のあとに呼ぶ）
export function updateSide() {
  if (!tallUI) return;
  const cat = catByKey[S.selKey], st = cat ? C.state[keyOf(cat)] : undefined;
  const usable = !!cat && colorUsable(cat);
  const pattern = !!cat && !!st && canPattern(cat);
  const lr = !!cat && !!st && lrOn(cat);
  const tools = !$('tools').hidden;
  if (adjusting && !tools) { adjusting = false; $('app').classList.remove('adjusting'); }
  const onPattern = pattern && S.colorTab === 'pattern';
  const set = (id: string, show: boolean, on: boolean) => {
    const b = $(id);
    b.hidden = !show;
    b.classList.toggle('on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  };
  set('sideColor', usable, colorShown());
  set('sidePattern', pattern, !adjusting && onPattern);
  set('sideAdjust', tools, adjusting);
  const lrBtn = $('sideLR');
  const pair = !!cat && isPair(S.selKey), slot = pair ? layerSlot[slotKeys(S.selKey)![0]] || 0 : lr ? S.lrSel : 0;
  lrBtn.hidden = pair ? false : !lr || adjusting || onPattern;
  lrBtn.classList.toggle('on', (pair || lr) && slot > 0);
  lrBtn.dataset.slot = String(slot); // 丸の塗り（style.css）
  $('sideLRNow').textContent = txt(LR_LABELS[slot]);
  lrBtn.setAttribute('aria-label', txt(pair ? 'side_lr' : 'lr_where') + ': ' + txt(LR_LABELS[slot]));
  syncHistory();
}
// 元に戻す・やり直すの押せる・押せない（history.ts の updateHistButtons と同じ）
export function syncHistory() {
  if (!tallUI) return;
  $<HTMLButtonElement>('sideUndo').disabled = $<HTMLButtonElement>('btnUndo').disabled;
  $<HTMLButtonElement>('sideRedo').disabled = $<HTMLButtonElement>('btnRedo').disabled;
}
export function bindSide() {
  if (!tallUI) return;
  const cat = () => catByKey[S.selKey];
  $('sideUndo').addEventListener('click', () => { histStep(-1); });
  $('sideRedo').addEventListener('click', () => { histStep(1); });
  $('sideColor').addEventListener('click', () => {
    if (colorShown()) { setColorsOff(true); updateSide(); return; } // 色を出しているときは、しまう
    setColorsOff(false);
    S.colorTab = 'color'; adjusting = false; $('app').classList.remove('adjusting'); if (cat()) buildColors(cat()); updateSide();
  });
  $('sidePattern').addEventListener('click', () => { setColorsOff(false); S.colorTab = 'pattern'; adjusting = false; $('app').classList.remove('adjusting'); if (cat()) buildColors(cat()); updateSide(); });
  $('sideLR').addEventListener('click', () => {
    const pair = slotKeys(S.selKey);
    if (pair && isPair(S.selKey)) { setPairSlot(pair, ((layerSlot[pair[0]] || 0) + 1) % 3); return; }
    S.lrSel = (S.lrSel + 1) % 3; if (cat()) buildColors(cat()); updateSide();
  });
  $('sideAdjust').addEventListener('click', () => { setAdjust(!adjusting); });
  updateSide();
}
